import * as types from '../actions/types';

const language = process.env.REACT_APP_LOCALE === 'is' ? process.env.REACT_APP_LOCALE : window.location.pathname.replace('/', '');
const initialState = {
  language,
};

const content = (state = initialState, action) => {
  switch (action.type) {
    case types.STORE_RESULTS:
      return { ...state, results: action.results };

    case types.STORE_REG:
      return { ...state, reg: action.reg };

    case types.STORE_ENV_URL:
      return { ...state, url: action.url };

    case types.STORE_ENV_TOKEN:
      return { ...state, token: action.token };

    case types.STORE_SELECTED:
      return { ...state, selected: action.selected };

    default:
      return state;
  }
};

export default content;



// WEBPACK FOOTER //
// ./src/reducers/content.js